import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import StandardButton from "@/components/buttons/StandardButton.vue";
import Icon from "@/components/icon/Icon.vue";
// @ts-ignore
import { Carousel, Slide, Navigation } from 'vue3-carousel';
/**
 * DEMO_MODE landing page (Vue). Mounted by Application/indexDemo.html when the boutique runs in demo
 * mode, instead of the normal home. Copy is i18n (src/locales → demoHome.*); CTAs navigate to the
 * signup / AI-creator URLs passed by the server (Play routes). Icons use the app's mdi Icon component.
 */
let DemoHome = class DemoHome extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "loggedIn", void 0);
    _defineProperty(this, "signupUrl", void 0);
    _defineProperty(this, "creatorUrl", void 0);
    _defineProperty(this, "trainingTypes", [{
      key: 'entire',
      icon: 'file-document-outline'
    }, {
      key: 'summary',
      icon: 'text-box-outline'
    }, {
      key: 'role',
      icon: 'target'
    }, {
      key: 'delta',
      icon: 'file-compare'
    }]);
    // Example speaches showcased in the carousel (public trial speaches).
    _defineProperty(this, "speaches", [{
      title: 'Pharmaceutical Deviation Management: From Detection to Closure',
      thumbnail: 'https://trial.speach.me/data/979a641b-29c6-453f-bb0b-945df39207db/photos/3456b2d5-df4d-46b9-906a-3af4862db2361787171627212500',
      url: 'https://trial.speach.me/s/f71c12e9f29/pharmaceutical-deviation-management-from-detection-to-closure',
      embedUrl: 'https://trial.speach.me/play-embedded/f71c12e9f29'
    }, {
      title: 'CAPA Essentials: Corrective and Preventive Action in Pharmaceutical Manufacturing',
      thumbnail: 'https://trial.speach.me/data/979a641b-29c6-453f-bb0b-945df39207db/photos/1d6d4dee-2375-4ede-aebc-57e960c4e0b81787075877989500',
      url: 'https://trial.speach.me/s/97c042333e8/capa-essentials-corrective-and-preventive-action-in-pharmaceutical-manufacturing',
      embedUrl: 'https://trial.speach.me/play-embedded/97c042333e8'
    }, {
      title: 'Gowning Process and Cleanroom Entry Training Module',
      thumbnail: 'https://trial.speach.me/data/979a641b-29c6-453f-bb0b-945df39207db/photos/763bfb54-4daf-4341-8912-ca2f4075926a17870701806791024',
      url: 'https://trial.speach.me/s/fd495353f34/gowning-process-and-cleanroom-entry-training-module',
      embedUrl: 'https://trial.speach.me/play-embedded/fd495353f34'
    }, {
      title: 'The Fundamentals of Good Clinical Practice — ICH E6(R3)',
      thumbnail: 'https://trial.speach.me/data/979a641b-29c6-453f-bb0b-945df39207db/photos/9df20ef2-88bf-43f2-817d-87937a1f59931787238983930500',
      url: 'https://trial.speach.me/s/3b0c664c4ef/the-fundamentals-of-good-clinical-practice-ich-e6-r3',
      embedUrl: 'https://trial.speach.me/play-embedded/3b0c664c4ef'
    }]);
    // Embed URL of the speach open in the full-screen player modal ('' = modal closed).
    _defineProperty(this, "playerUrl", '');
  }
  goCreator() {
    if (this.creatorUrl) {
      window.location.href = this.creatorUrl;
    }
  }
  openPlayer(s) {
    this.playerUrl = s.embedUrl;
  }
  // Closing removes the iframe from the DOM → playback stops.
  closePlayer() {
    this.playerUrl = '';
  }
};
__decorate([Prop({
  default: 'false'
})], DemoHome.prototype, "loggedIn", void 0);
__decorate([Prop({
  default: ''
})], DemoHome.prototype, "signupUrl", void 0);
__decorate([Prop({
  default: ''
})], DemoHome.prototype, "creatorUrl", void 0);
DemoHome = __decorate([Component({
  components: {
    StandardButton,
    Icon,
    Carousel,
    Slide,
    Navigation
  }
})], DemoHome);
export default DemoHome;